import React from 'react';
import { Modal } from '../../Modal';
import { Button } from '../../../subkit-ui';
import { makeAddressFromGeocoderResult } from './maps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AddressConfirmModal = function AddressConfirmModal(_ref) {
  var userEnteredAddress = _ref.userEnteredAddress,
      suggestedAddress = _ref.suggestedAddress,
      addressPicked = _ref.addressPicked,
      showModal = _ref.showModal,
      setModal = _ref.setModal;
  if (!showModal) return null;
  return /*#__PURE__*/_jsx(Modal, {
    showModal: showModal,
    setModal: setModal,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col md:flex-row gap-8 md:gap-0",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "mr-42 flex-1 flex flex-col content-between",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mt-0 mb-8 fw-600 text-lg",
          children: "You entered:"
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: userEnteredAddress.split(', ').map(function (line) {
            return /*#__PURE__*/_jsx("div", {
              children: line
            }, line);
          })
        }), /*#__PURE__*/_jsx(Button, {
          text: "Use Address",
          onClick: function onClick() {
            return addressPicked(userEnteredAddress);
          },
          type: "secondary",
          "data-cy": "use-address-left",
          classes: "w-full md:w-auto mt-4"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "mr-36 flex-1 flex flex-col content-between",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mt-0 mb-8 fw-600 text-lg",
          children: "We suggest:"
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: makeAddressFromGeocoderResult(suggestedAddress).split(', ').map(function (line) {
            return /*#__PURE__*/_jsx("div", {
              children: line
            }, line);
          })
        }), /*#__PURE__*/_jsx(Button, {
          text: "Use Address",
          onClick: function onClick() {
            return addressPicked(suggestedAddress);
          },
          type: "primary",
          "data-cy": "use-address-right",
          classes: "w-full md:w-auto mt-4"
        })]
      })]
    })
  });
};
export default AddressConfirmModal;